import { render, staticRenderFns } from "./AttendeesPage.vue?vue&type=template&id=5a4833de&scoped=true"
import script from "./AttendeesPage.vue?vue&type=script&lang=js"
export * from "./AttendeesPage.vue?vue&type=script&lang=js"
import style0 from "./AttendeesPage.vue?vue&type=style&index=0&id=5a4833de&prod&lang=scss&scoped=true"
import style1 from "./AttendeesPage.vue?vue&type=style&index=1&id=5a4833de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4833de",
  null
  
)

export default component.exports